import { useEffect } from 'react'; 
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import Footer from '../Footer';
import './PortfolioFrame.css';

const PortfolioFrame = ({children, classes}) => {
    useEffect(()=>{
        const page = document.querySelector("#PortfolioFrame");
        page.classList.add("stylesPortfolioFrame");
        return(()=>{
            page.classList.remove("stylesPortfolioFrame");
        });
    });
    return(
        <Grid container justifyContent='center' id="PortfolioFrame" className={classes ? classes : ''}>
            {children}
            <Grid item container>
                <Footer />

            </Grid>
        </Grid>
    );
}

export default PortfolioFrame;